<img
  ngSrc="../../../../../assets/images/highlight_end_text.svg"
  alt=""
  height="{{height}}"
  width="{{width}}"
>